module.exports = __webpack_public_path__ + "img/resourse1.f09d2938.png";